<script>
  import { Icon, Bell, CheckCircle } from "svelte-hero-icons";
  import { onMount } from "svelte";
  import { createNotificationsStore } from "./Knock/notifications";
  import { clickOutside } from "$utils/clickOutside";
  import Notification from "./Knock/Notification.svelte";

  // svelte-ignore unused-export-let
  export let live;
  export let public_key;
  export let signed_key;
  export let channel_id;
  export let org_user_id;

  let isOpen = false;
  let notifications = createNotificationsStore();
  let viewButton;

  function toggleOpen() {
    isOpen = !isOpen;
  }

  function close() {
    isOpen = false;
  }

  onMount(async () => {
    // Initialize the notifications store
    await notifications.init({ public_key, signed_key, org_user_id, channel_id });
  });
</script>

<div class="relative">
  <button
    bind:this={viewButton}
    on:click={toggleOpen}
    type="button"
    class="p-2.5 text-gray-400 hover:text-gray-500 relative"
  >
    <span class="sr-only">View notifications</span>
    <Icon src={Bell} class="h-6 w-6" />
    {#if $notifications.unreadCount > 0}
      <span
        class="absolute w-4 h-4 top-1.5 right-1.5 bg-red-500 rounded-full text-white text-[9px] inline-flex items-center justify-center"
      >
        {$notifications.unreadCount}
      </span>
    {/if}
  </button>

  <div
    use:clickOutside={[viewButton]}
    on:clickoutside={close}
    class:hidden={!isOpen}
    class="absolute top-auto right-0 z-50 min-w-[80vw] md:min-w-[400px]"
  >
    <div
      class="bg-white rounded border border-gray-200 shadow-md pt-4 text-sm divide-y divide-y-gray-200"
    >
      <div class="inline-flex justify-between w-full px-4 pb-4 whitespace-nowrap">
        <span class="font-bold"
          >Notifications <span class="font-normal text-xs align-text-bottom"
            >({$notifications.totalCount})</span
          ></span
        >
        <button
          class:hidden={$notifications.isWaiting}
          class="inline-flex items-center hover:text-slate-600 text-slate-400 cursor-pointer"
          on:click={() => notifications.markAllRead()}
        >
          Mark all as read <Icon src={CheckCircle} class="ml-1 w-4 h-4" />
        </button>
      </div>

      <div
        class:hidden={!$notifications.isWaiting}
        class="pt-6 pb-4 flex flex-col gap-4 justify-center items-center"
      >
        <div class="text-slate-400">Waiting for notifications...</div>
      </div>

      <div
        class:hidden={$notifications.notifications.length > 0}
        class="pt-6 pb-4 flex flex-col gap-4 justify-center items-center"
      >
        <div class="text-slate-400">No notifications</div>
      </div>

      <div
        class:hidden={$notifications.isWaiting || $notifications.notifications.length === 0}
        class="divide-y divide-y-gray-400 max-h-96 overflow-y-auto"
      >
        {#each $notifications.notifications as item}
          <Notification
            {item}
            on:read={({ detail }) => notifications.markRead(detail.id)}
            on:archive={({ detail }) => notifications.archive(detail.id)}
          />
        {/each}
      </div>
    </div>
  </div>
</div>
